import '@/styles/theme.css';

import type { IPicsartToolPubSub } from '@picsart/miniapps-sdk/types';
import { createRoot } from 'react-dom/client';

import App from './components/App';
import setupContext from './miniappContext';
import Wrappers from './Wrappers';

const setup = ({ containerId, pubsub }: { containerId: string; pubsub?: IPicsartToolPubSub }) => {
  const container = document.getElementById(containerId)!;
  const root = createRoot(container);
  setupContext({ pubsub });
  root.render(
    <Wrappers>
      <App />
    </Wrappers>,
  );

  return {
    unmount: () => root.unmount(),
  };
};

export default setup;
